export default __webpack_public_path__ + "static/media/ancailinciuin3.02be8624.jpeg";